import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useWalletCredits = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.walletCredits, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getWalletCredits(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        clinicWalletCredits: res.data.data.clinic_wallet_credits,
        providerWalletCredits: res.data.data.provider_wallet_credits,
      };
      return composeResponse;
    },
    options,
  );
};
